import { ChipDownContainer } from "@similarweb/ui-components";
import utils from "app/Shared/utils";
import { i18nFilter } from "app/filters/i18nFilter";
import { categoryClassIconFilter, i18nCategoryFilter, subCategoryFilter } from "app/filters/ngFilters";
import styled from "styled-components";
import { CategoryItem } from "app/components/React/CategoriesDropdown/CategoryDropdown";
import type { IFilterItem } from "app/pages/website-analysis/traffic-sources/display-ads/publishers/common/types";

const i18nCategory = i18nCategoryFilter();
const categoryClassIcon = categoryClassIconFilter();
const subCategory = subCategoryFilter();
const i18n = i18nFilter();

interface ICategoryFilter {
    selectedCategory: string;
    onSelectCategory(category: any): void;
    allCategories: IFilterItem[];
}

const convertCategory = ({ Count, Name, Sons = [], id }, parentId = null) => {
    const text = `${i18nCategory(Name)}${Count ? ` (${Count})` : ``}`;
    return {
        text,
        id,
        isCustomCategory: false,
        isChild: Sons.length === 0,
        icon: categoryClassIcon(id),
        forApi: `${parentId ? `${parentId}~` : ``}${id}`,
    };
};

const CategoryItemContainer = styled(CategoryItem)`
    font-weight: 400;
`;

export const CategoryFilter: React.FC<ICategoryFilter> = (props) => {
    const { selectedCategory, onSelectCategory, allCategories } = props;

    const getCategoriesOptions = () => {
        const categories = utils.manipulateCategories(allCategories);
        const items = categories.reduce((result, category) => {
            if (category.Sons.length > 0) {
                return [
                    ...result,
                    convertCategory(category),
                    ...category.Sons.map((son) => convertCategory(son, category.id)),
                ];
            } else {
                return [...result, convertCategory(category)];
            }
        }, []);

        return items.map((item, index) => {
            return (
                <CategoryItemContainer
                    {...item}
                    key={index}
                    selected={item.forApi === selectedCategory}
                />
            );
        });
    };

    const selectedText = selectedCategory ? subCategory(selectedCategory) : "";
    return (
        <ChipDownContainer
            width={340}
            onClick={onSelectCategory}
            selectedText={selectedText}
            onCloseItem={() => onSelectCategory(null)}
            buttonText={i18n("common.category.all")}
            searchPlaceHolder={i18n("industry.filter.search")}
            noResultsMessage={i18n("dropdown.no.results")}
            tooltipDisabled={true}
            hasSearch={true}
            disabled={!allCategories || allCategories.length === 0}
        >
            {getCategoriesOptions()}
        </ChipDownContainer>
    );
};
